import { NonFunctionProperties } from "@/Common/Models/NonFunctionProperties";
import { CareElementType } from "./CareElementType";

export class BaseCareElementConfig {
    public CareElementType: CareElementType;
    public Name: string;
    public SubSectionName?: string;

    public constructor(init: NonFunctionProperties<BaseCareElementConfig>) {
        Object.assign(this, init);
        this.SubSectionName = init?.SubSectionName ?? "";
    }
}
